import { ParseMapError } from "../../errors";
import type { VictoryCondition } from "../types";
import { VICTORY_CONDITIONS } from "../types";

const VICTORY_CONDITION_SET = new Set<string>(VICTORY_CONDITIONS);

export function parseVictoryConditions(value: unknown): VictoryCondition[] {
  if (value === undefined) return ["rout"];
  if (!Array.isArray(value) || value.length !== 1) {
    throw new ParseMapError("victoryConditions must be an array with exactly one condition");
  }
  const condition = value[0];
  if (typeof condition !== "string" || !VICTORY_CONDITION_SET.has(condition)) {
    throw new ParseMapError(`Invalid victory condition: ${JSON.stringify(condition)}`);
  }
  return [condition as VictoryCondition];
}

export function parseCaptureCityTarget({
  value,
  victoryConditions,
}: {
  value: unknown;
  victoryConditions: VictoryCondition[];
}): number | undefined {
  const isCapture = victoryConditions[0] === "capture";
  if (!isCapture) {
    if (value !== undefined) {
      throw new ParseMapError("captureCityTarget is only valid when victoryConditions is capture");
    }
    return undefined;
  }
  if (typeof value !== "number" || !Number.isInteger(value) || value < 1) {
    throw new ParseMapError("captureCityTarget must be a positive integer when victory is capture");
  }
  return value;
}

export function shouldSerializeVictoryConditions(
  victoryConditions: VictoryCondition[] | undefined,
): boolean {
  const conditions = victoryConditions ?? ["rout"];
  return !(conditions.length === 1 && conditions[0] === "rout");
}
